// Function to perform the subtraction
export const subtractArrays = (values: string[], terms: string[]) => {
	const termCounts = terms.reduce((acc: { [key: string]: number }, term) => {
		acc[term] = (acc[term] || 0) + 1
		return acc
	}, {})

	return values.filter(value => {
		if (termCounts[value]) {
			termCounts[value]--
			return false
		}
		return true
	})
}
